module.exports = __webpack_public_path__ + "static/media/event_calender.7d682f85.png";